import { Box, Typography, Grid, Button } from '@mui/material';
import { ProgramTypeCard } from './ProgramTypeCard';

export function ProgramLaunchPage({
  onPrevious,
  onSelectMasterclass,
  onSelectMentorship,
  onSelectGuidedMasterclass
}: {
  onPrevious: () => void;
  onSelectMasterclass: () => void;
  onSelectMentorship: () => void;
  onSelectGuidedMasterclass: () => void;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'black'
      }}
    >
      {/* conteúdo principal */}
      <Box
        sx={{
          flex: 1,
          px: { xs: 3, sm: 5 },
          py: { xs: 6, sm: 10 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5
          }}
        >
          <Typography fontSize={16} fontWeight={600} color="#FDFDFD" textAlign="center">
            Perfect! What type of program do you want to launch?
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <ProgramTypeCard
                title="Masterclass"
                description="An AI-generated, self-paced learning program built using your inputs and internal documents. Ideal for scalable, on-demand training that adapts to your documentation, goals, and learners."
                onSelect={onSelectMasterclass}
              />
            </Grid>

            <Grid item>
              <ProgramTypeCard
                title="Mentorship"
                description="A lightweight development path powered by internal mentors. Best for informal growth, knowledge sharing, or supporting individuals without structured content."
                onSelect={onSelectMentorship}
              />
            </Grid>

            <Grid item>
              <ProgramTypeCard
                title="Guided Masterclass"
                description="A blended experience combining self-paced Masterclass content with scheduled human touchpoints."
                onSelect={onSelectGuidedMasterclass}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* footer */}
      <Box
        sx={{
          borderTop: '1px solid #2A2A2A',
          p: 3,
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Button
          onClick={onPrevious}
          sx={{
            backgroundColor: '#1C1C1C',
            borderRadius: '6px',
            color: '#FDFDFD',
            textTransform: 'none',
            fontSize: 14,
            px: 2.5,
            '&:hover': { backgroundColor: '#2b2b2b' }
          }}
        >
          Previous
        </Button>
      </Box>
    </Box>
  );
}
